import type { Venta } from '@/api/tienda.api';
import { dinero, fecha } from '@/lib/formato-tienda';

/**
 * EL TEXTO DEL COMPROBANTE — aparte del componente a propósito.
 *
 * Un archivo que exporta un componente Y una función rompe el fast refresh de
 * Vite: al tocar el modal, React recarga la pantalla entera. Y además así se
 * puede probar la aritmética sin montar nada.
 */

/** El texto plano, el que se pega en WhatsApp. */
export function textoDelComprobante(
  venta: Venta,
  negocio: string,
): string {
  const piezas = venta.lineas.reduce((a, l) => a + l.cantidad, 0);
  const bruto = venta.lineas.reduce((a, l) => a + l.unitPrice * l.cantidad - l.descuento, 0);

  const lineas: string[] = [
    `*${negocio}*`,
    `Comprobante ${venta.numero} · ${fecha(venta.createdAt)}`,
    '',
  ];

  if (venta.cliente) lineas.push(`Para: ${venta.cliente.nombre}`, '');

  for (const l of venta.lineas) {
    const nombre = l.productVariant.product.name;
    const codigo = l.productVariant.product.sku ? `${l.productVariant.product.sku} ` : '';
    lineas.push(
      `${l.cantidad}× ${codigo}${nombre} (${l.productVariant.label})` +
        `  ${dinero(l.unitPrice * l.cantidad - l.descuento)}`,
    );
  }

  lineas.push('');
  // Solo se enseñan las líneas que existen: un «Descuento: RD$0» hace dudar de
  // si hubo un descuento que no se aplicó.
  if (venta.descuento > 0) {
    lineas.push(`Subtotal: ${dinero(bruto)}`, `Descuento: −${dinero(venta.descuento)}`);
  }
  if (venta.envio > 0) lineas.push(`Envío: ${dinero(venta.envio)}`);
  lineas.push(`*TOTAL: ${dinero(venta.total)}*`);
  lineas.push('', `${piezas} pieza${piezas === 1 ? '' : 's'}`);

  if (venta.formaDePago) lineas.push(`Pago: ${venta.formaDePago}`);
  if (venta.estado === 'CONFIRMADA' && !venta.cobrado) {
    lineas.push('Pendiente de cobro al entregar.');
  }
  if (venta.direccion) lineas.push('', `Entrega: ${venta.direccion}`);

  return lineas.join('\n');
}
